export enum AccountType{
    DISTRIBUTOR='distributeur',
    AGENCY='agence',
    COMMERCIAL='commercial',
    KIOSQUE='kiosque'
}